import { useContext, useEffect } from 'react';
import ScrollToContext from 'providers/ScrollTo/ScrollTo.context';

export function useLockScrollOnReroute() {
  const { setShouldScroll } = useContext(ScrollToContext);

  useEffect(() => {
    setShouldScroll(false);

    return () => {
      setShouldScroll(true);
    };
  }, [setShouldScroll]);
}
